module.exports = __webpack_public_path__ + "img/c6e96cca4df78768d40a5d73bb7340d5.8d190928.jpg";